export const genderIdentity = {
  man: 1,
  woman: 2,
  nonBinary: 3,
  queer: 6,
  preferNotToSay: 5,
};
